<template>
    <el-dialog
      top="5vh"
      width="70%"
      :modal="false"
      :visible.sync="dialogVisible"
      @opened='dialogOpened'>

      <div slot="title" style="padding-top:10px;">
        <span style="font-size:25px;">填写表单</span>
        <!-- 加载表单 -->
        <LoadFormData class="load_form_btn" @selected="onLoadFormDataSelected" />
      </div>

      <TicketTaskForm
        style = "margin:0 10px;"
        v-model = "taskForm"
        ref = "ref2"
        :ticketNo = "ticketNo"
        :workflowId = "workflowId"
        @cancel = "onCancel"
        @afterPost = "afterPost"
        @submitAssignToWorkflow = "submitAssignToWorkflow"/>
    </el-dialog>
</template>

<script>
export default {
  name: "TicketTaskFormDialog",

  data() {
    return {
      taskForm : {},
      dialogVisible : false,
      ticketNo : null,
      ticketNo_1 : null,
      workflowId : null
    };
  },

  methods: {
    onLoadFormDataSelected( props ) {
      _message('已加载数据');

      this.taskForm = Object.assign({}, props||{}, this.taskForm||{});
    },

    onCancel() {
      this.dialogVisible = false;
    },

    submitAssignToWorkflow() {
      sdk.TicketApi().assignToWorkflowWithForm({
        ticketNo : this.ticketNo_1,
        workflowId : this.workflowId,
        form : this.taskForm
      }).then( res=> {
        history.go(0); // 刷新一下
      }, err => {
        _message(JSON.stringify(err));
      });
    },

    afterPost() {
      this.dialogVisible = false;
      this.$emit('afterPost', null);
    },

    dialogOpened() {
      console.log('#51 TicketTaskFormDialog.dialogOpened', this);
      this.$refs.ref2.listForm();
    },

    showStartFormDialog( _workflowId, _ticketNo ) {
      this.workflowId = _workflowId;
      this.ticketNo_1 = _ticketNo;
      this.dialogVisible = true;
    },

    showCompleteDialog( _ticketNo ) {
      this.ticketNo = _ticketNo;
      this.dialogVisible = true;
    }
  }
};
</script>

<style scoped>
.load_form_btn {
  margin-right: 50px;
  display:block;
  float:right;
  cursor:pointer;
  border:1px solid #DCDFE6;
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketTaskFormDialog.vue